import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.BlackWindow,
  voices: {
    main: {
      description:
        "cool alto spy voice, low smoky confidence, Eastern European-flavored precision without imitation, minimal vibrato, quiet menace from a close lavalier style",
      seed: 10325,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      { id: "select_1", text: "Stepping out of the shadows." },
      { id: "select_2", text: "Attention team, Black Window is combat-ready." },
      { id: "select_3", text: "Black Window is ready to deploy." },
      { id: "select_4", text: "Window standing by." },
      { id: "select_5", text: "I'm always picking up after you boys." },
    ],
    spawn: [
      { id: "spawn_1", text: "This battle calls for special ammo…" },
      {
        id: "spawn_2",
        text: "If your flaming friend wants to bless my bullets, Jean, I won't say no.",
      },
      {
        id: "spawn_3",
        text: "Once I'm locked on, no one's escaping my sights…",
      },
      {
        id: "spawn_4",
        text: "I always feel more focused when you're watching my back, Barton.",
      },
      {
        id: "spawn_5",
        text: "I'm more than a hundred years old. Never would have imagined that back in the day.",
      },
      {
        id: "spawn_6",
        text: "One shot is all I need for a Doombot…no matter what timeline it's from.",
      },
      {
        id: "spawn_7",
        text: "Heroes get the job done. In times like these, we can't afford hesitation.",
      },
      {
        id: "spawn_8",
        text: "Doom, Loki, Hela…that's a little too much green. Time to paint things black.",
      },
      {
        id: "spawn_9",
        text: "Secrets ALWAYS come out, but I'm not afraid of showing the world who I really am.",
      },
      {
        id: "spawn_10",
        text: "It doesn't matter if a conflict is geological, commercial or even multiversal, I'd rather end things quietly.",
      },
      {
        id: "spawn_11",
        text: "When this is all said and done, the Red Room will resume business as usual.",
      },
      {
        id: "spawn_12",
        text: "Time to put Alchemax's tech to good use for once…",
      },
      { id: "spawn_13", text: "The future is at my fingertips!" },
      {
        id: "spawn_14",
        text: "Using Alchemax's weapons against their own interests feels so right.",
      },
      {
        id: "spawn_15",
        text: "Spies know that truly observant people are rare. And dangerous.",
      },
      {
        id: "spawn_16",
        text: "I've been around a long time, and I've learned a little too much about how to hurt people.",
      },
      {
        id: "spawn_17",
        text: "I've done things I regret. Now I do things I can be proud of.",
      },
      {
        id: "spawn_18",
        text: "You don't have to run away from your past. Just look it in the eye and say: I'm better than that now.",
      },
      {
        id: "spawn_19",
        text: "I was terrorized, broken and remade in the Red Room. Now I command it.",
      },
      {
        id: "spawn_20",
        text: "Nothing happens in any world without me knowing about it.",
      },
      { id: "spawn_21", text: "Knowing is literally half the battle." },
      {
        id: "spawn_22",
        text: "Sometimes the right thing is the hardest thing. Do it anyway.",
      },
      {
        id: "spawn_23",
        text: "People like Doom always overreach. People like us have to put things back together.",
      },
      {
        id: "spawn_24",
        text: "There will always be Avengers. The ones from my world, well...",
      },
      {
        id: "spawn_25",
        text: "Ultron's been in everything. Files, surveillance. Probably knows more about us than we know about each other.",
      },
      {
        id: "spawn_26",
        text: "When you programmed Ultron to protect the human race, Stark, you amazingly failed.",
      },
      {
        id: "spawn_27",
        text: "The genie's out of the bottle. Clear and present is Ultron.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "Window is operational again." },
      { id: "respawn_2", text: "So…we haven't won yet?" },
      { id: "respawn_3", text: "I'll finish the job this time." },
      {
        id: "respawn_4",
        text: "No, NOT after everything I've been through in the Red Room!",
      },
      { id: "respawn_5", text: "Back where I belong." },
    ],
    ult_ally: [
      { id: "ult_ally_1", text: "Targeted for extermination." },
      { id: "ult_ally_2", text: "Mind the exploding plasma." },
    ],
    ult_enemy: [
      { id: "ult_enemy_1", text: "Perfect precision." },
      { id: "ult_enemy_2", text: "Plasma..." },
      { id: "ult_enemy_3", text: "...burst!" },
    ],
    secondary: [
      { id: "secondary_1", text: "Slow it down!" },
      { id: "secondary_2", text: "Not so fast…" },
      { id: "secondary_3", text: "Let's change the pace…" },
    ],
    ability2: [
      { id: "ability2_1", text: "Air strike!" },
      { id: "ability2_2", text: "Don't look up!" },
      { id: "ability2_3", text: "Window's bite!" },
    ],
    ability3: [
      { id: "ability3_1", text: "Window's Strike!" },
      { id: "ability3_2", text: "Pulse charge!" },
      { id: "ability3_3", text: "High voltage!" },
      { id: "ability3_4", text: "Let's see who's out there…" },
      { id: "ability3_5", text: "Can't hide your body heat." },
      { id: "ability3_6", text: "Come out… Come out wherever you are…" },
    ],
    kill: [
      { id: "kill_1", text: "Enemy down." },
      { id: "kill_2", text: "Target neutralized." },
      { id: "kill_3", text: "Looking for a new challenge." },
      { id: "kill_4", text: "The Window's bite is lethal." },
      { id: "kill_5", text: "Another one bites the dust." },
    ],
    multikill: [
      { id: "multikill_1", text: "Triple play!" },
      { id: "multikill_2", text: "Trifecta!" },
      { id: "multikill_3", text: "Three and counting." },
      { id: "multikill_4", text: "Five's a pretty good streak." },
      { id: "multikill_5", text: "Looking for number six…" },
      { id: "multikill_6", text: "That's five. I'm running out of targets." },
      { id: "multikill_7", text: "Sorry. I love working solo." },
      { id: "multikill_8", text: "I couldn't help myself." },
      { id: "multikill_9", text: "They all went down so easy…" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Back to fighting strength." },
      { id: "low_hp_2", text: "Oof. I needed that." },
    ],
    healed: [
      { id: "healed_1", text: "That topped me off, thanks." },
      { id: "healed_2", text: "Every little bit helps." },
      { id: "healed_3", text: "R and R in a box." },
      { id: "healed_4", text: "That put a spring in my step." },
    ],
  },
} satisfies VoiceScript;

export default script;
